export type TowelStatus = 'disponible' | 'en_uso' | 'lavanderia' | 'merma'

export interface Towel {
  id: string
  codigo: string
  tipo: string
  estado: TowelStatus
  zone_id: string

  zone?: {
    nombre: string
  }
}

export type TowelStatusConfig = {
  status: TowelStatus
  title: string
  badge: string
}

export const TOWEL_STATUS_CONFIG: TowelStatusConfig[] = [
  {
    status: 'disponible',
    title: 'Toallas Disponibles',
    badge: 'light-success',
  },
  {
    status: 'en_uso',
    title: 'Toallas En Uso',
    badge: 'light-warning',
  },
  {
    status: 'lavanderia',
    title: 'En Lavandería',
    badge: 'light-info',
  },
  {
    status: 'merma',
    title: 'Merma',
    badge: 'light-danger',
  },
]

export const getStatusConfig = (status: TowelStatus) => {
  return TOWEL_STATUS_CONFIG.find((s) => s.status === status)
}
